import { DOCUMENT } from "@angular/common";
import { Component, Inject, OnInit } from "@angular/core";
import { AuthService } from "@auth0/auth0-angular";
import { NGXLogger } from "ngx-logger";
import { MessageService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { Router } from "@angular/router";
import { ActivatedRoute } from "@angular/router";
import { ButtonModule } from "primeng/button";
import { LottieComponent, AnimationOptions } from "ngx-lottie";
import player from 'lottie-web';

// Nota: questa funzione deve essere esportata per poter essere usata nell'importazione
export function playerFactory() {
  return player;
}

interface Release {
  name: string;
  code: string;
}

@Component({
  selector: "home-not-logged",
  standalone: true,
  imports: [
    ButtonModule,
    LottieComponent
  ],
  providers: [
    DialogService,
    MessageService
  ],
  templateUrl: "./not_logged.component.html",
  styleUrls: ["./not_logged.component.css"],
})
export class NotLoggedHomeComponent implements OnInit {

  lottieConfig: AnimationOptions;
  lottieConfig_bg: AnimationOptions;
  anim: any;
  bgAnim: any;

  constructor(
    public dialogService: DialogService,
    @Inject(DOCUMENT) private doc: Document,
    private logger: NGXLogger,
    public auth: AuthService,
  ) {
    this.lottieConfig = {
      path: 'assets/animations/NOT_LOGGED.json',
      autoplay: true,
      loop: true,
      renderer: 'svg',
    };
    this.lottieConfig_bg = {
      path: 'assets/animations/HOME_BG.json',
      autoplay: true,
      loop: true,
      renderer: 'svg',
    };
  }

  ngOnInit(): void {
    //this.logger.info("[INIT @ NOT LOGGED COMPONENT]");
  }

  loginWithRedirect() {
    this.auth.loginWithRedirect().subscribe((res) => {
    });
  }

  animationCreated(animation: any): void {
    // Verifica quale animazione è stata creata basandosi sul path
    if (animation && animation.animationData && animation.animationData.assets) {
      const path = animation.animationData.assets[0]?.p || '';
      if (path.includes('HOME_BG')) {
        this.bgAnim = animation;
      } else {
        this.anim = animation;
      }
    } else {
    }
  }

  goToVertical(){
    window.open('https://www.latitudesrl.it/', '_blank');
  }
}
